import * as React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { InputLabel } from "@mui/material";

export default function SecureMessageRadioButton({parentCallback}) {
  const [age, setAge] = React.useState(0);

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  // console.log(age);

  const sendData = () => {
    parentCallback(age);
  };

  React.useEffect(() => {
    sendData();
  }, [handleChange]);

  return (
    <>

      <FormControl value={age} onChange={handleChange}
  
      >
      {/* <InputLabel id="demo-simple-select-autowidth-label">
      Secure(Encrypt) Message
                          </InputLabel> */}
        <RadioGroup
          value={age}
          row
          aria-labelledby="demo-row-radio-buttons-group-label"
          name="row-radio-buttons-group"
        >
          <FormControlLabel
        
            value="None"
            // control={<Radio/>}
            control={<Radio required={true} />}
            label="None"
          />
          {/* <FormControlLabel
            value="Mask Number"
            // control={<Radio />}
            control={<Radio required={true} />}
            label="Mask Number"
          /> */}
          <FormControlLabel
            value="Hashing"
            // control={<Radio />}
            control={<Radio required={true} />}
            label="Hashing"
          />
          <FormControlLabel
            value="DES Encryption"
            control={<Radio />}
            label="DES Encryption"
          />
          <FormControlLabel
            value="AES256 Encryption"
            control={<Radio />}
            label="AES256 Encryption"
          />
        <FormControlLabel
            value="Do Not Store"
            control={<Radio />}
            label="Do Not Store"
          />
        </RadioGroup>
      </FormControl>
    </>
  );
}
